<template>
  <div id="app">
    <template v-if="['/exhibition', '/goin/contact-mobile'].includes($route.path)">
      <newHeader></newHeader>
      <div id="container">
      <router-view />
    </div>
    <ExhibitionFooter></ExhibitionFooter>
    <GoTop></GoTop>
    </template>
    <template v-else-if="['/30thAnniversary'].includes($route.path)">
      <div id="container">
      <router-view v-if="isRouterAlive" />
    </div></template>
    <template v-else>
      <newHeader></newHeader>
    <div id="container">
      <router-view v-if="isRouterAlive" />
    </div>
    <Footer></Footer>
    <GoTop></GoTop>
    </template>
    <!--百捷 开始-->
    <!-- <newHeader></newHeader>
    <div id="container">
      <router-view v-if="isRouterAlive" />
    </div>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>-->
   <!--百捷 结束-->
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
};
</script>

<style scoped>
#container {
  min-height: 100vh;
  /* overflow-x: hidden; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue